/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * AGOS API
 * v1 is a faithful port of the HellKitchen Express API: same paths under /api/v1, same request and response shapes, same status codes and error messages.
 * OpenAPI spec version: v1
 */
import { useMutation, useQuery } from '@tanstack/react-query'
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query'

import type {
  PostUploadImageBody,
  PostUploadMediaBody,
  UploadedImage,
  UploadedMedia,
} from '../../model'

import { customFetch } from '../../../custom-fetch'

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K }
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    })
  }
  return result
}

export const getPostUploadMediaUrl = () => {
  return `/api/v1/upload-media`
}

/**
 * @summary Upload an image or video to the media library
 */
export const postUploadMedia = async (
  postUploadMediaBody?: PostUploadMediaBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<UploadedMedia> => {
  return customFetch<UploadedMedia>(getPostUploadMediaUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postUploadMediaBody),
  })
}

export const getPostUploadMediaMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postUploadMedia>>,
    TError,
    { data?: PostUploadMediaBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postUploadMedia>>,
  TError,
  { data?: PostUploadMediaBody },
  TContext
> => {
  const mutationKey = ['postUploadMedia']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postUploadMedia>>,
    { data?: PostUploadMediaBody }
  > = (props) => {
    const { data } = props ?? {}

    return postUploadMedia(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostUploadMediaMutationResult = NonNullable<Awaited<ReturnType<typeof postUploadMedia>>>
export type PostUploadMediaMutationBody = PostUploadMediaBody | undefined
export type PostUploadMediaMutationError = unknown

/**
 * @summary Upload an image or video to the media library
 */
export const usePostUploadMedia = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postUploadMedia>>,
      TError,
      { data?: PostUploadMediaBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postUploadMedia>>,
  TError,
  { data?: PostUploadMediaBody },
  TContext
> => {
  return useMutation(getPostUploadMediaMutationOptions(options), queryClient)
}
export const getPostUploadImageUrl = () => {
  return `/api/v1/upload-image`
}

/**
 * @summary Upload a menu photograph
 */
export const postUploadImage = async (
  postUploadImageBody?: PostUploadImageBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<UploadedImage> => {
  return customFetch<UploadedImage>(getPostUploadImageUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postUploadImageBody),
  })
}

export const getPostUploadImageMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postUploadImage>>,
    TError,
    { data?: PostUploadImageBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postUploadImage>>,
  TError,
  { data?: PostUploadImageBody },
  TContext
> => {
  const mutationKey = ['postUploadImage']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postUploadImage>>,
    { data?: PostUploadImageBody }
  > = (props) => {
    const { data } = props ?? {}

    return postUploadImage(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostUploadImageMutationResult = NonNullable<Awaited<ReturnType<typeof postUploadImage>>>
export type PostUploadImageMutationBody = PostUploadImageBody | undefined
export type PostUploadImageMutationError = unknown

/**
 * @summary Upload a menu photograph
 */
export const usePostUploadImage = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postUploadImage>>,
      TError,
      { data?: PostUploadImageBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postUploadImage>>,
  TError,
  { data?: PostUploadImageBody },
  TContext
> => {
  return useMutation(getPostUploadImageMutationOptions(options), queryClient)
}
export const getGetUploadsFilenameUrl = (filename: string) => {
  return `/api/v1/uploads/${filename}`
}

/**
 * @summary Serve an uploaded image
 */
export const getUploadsFilename = async (
  filename: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<string> => {
  return customFetch<string>(getGetUploadsFilenameUrl(filename), {
    ...options,
    method: 'GET',
  })
}

export const getGetUploadsFilenameQueryKey = (filename: string) => {
  return [`/api/v1/uploads/${filename}`] as const
}

export const getGetUploadsFilenameQueryOptions = <
  TData = Awaited<ReturnType<typeof getUploadsFilename>>,
  TError = unknown,
>(
  filename: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUploadsFilename>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetUploadsFilenameQueryKey(filename)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getUploadsFilename>>> = ({ signal }) =>
    getUploadsFilename(filename, { signal, ...requestOptions })

  return {
    queryKey,
    queryFn,
    enabled: filename !== null && filename !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getUploadsFilename>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }
}

export type GetUploadsFilenameQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUploadsFilename>>
>
export type GetUploadsFilenameQueryError = unknown

export function useGetUploadsFilename<
  TData = Awaited<ReturnType<typeof getUploadsFilename>>,
  TError = unknown,
>(
  filename: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUploadsFilename>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUploadsFilename>>,
          TError,
          Awaited<ReturnType<typeof getUploadsFilename>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUploadsFilename<
  TData = Awaited<ReturnType<typeof getUploadsFilename>>,
  TError = unknown,
>(
  filename: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUploadsFilename>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUploadsFilename>>,
          TError,
          Awaited<ReturnType<typeof getUploadsFilename>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUploadsFilename<
  TData = Awaited<ReturnType<typeof getUploadsFilename>>,
  TError = unknown,
>(
  filename: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUploadsFilename>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Serve an uploaded image
 */

export function useGetUploadsFilename<
  TData = Awaited<ReturnType<typeof getUploadsFilename>>,
  TError = unknown,
>(
  filename: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUploadsFilename>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetUploadsFilenameQueryOptions(filename, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetApiUploadsFilenameUrl = (filename: string) => {
  return `/api/uploads/${filename}`
}

/**
 * @summary Serve an uploaded image (legacy unversioned path, referenced from the database)
 */
export const getApiUploadsFilename = async (
  filename: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<Blob> => {
  return customFetch<Blob>(getGetApiUploadsFilenameUrl(filename), {
    ...options,
    method: 'GET',
  })
}

export const getGetApiUploadsFilenameQueryKey = (filename: string) => {
  return [`/api/uploads/${filename}`] as const
}

export const getGetApiUploadsFilenameQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiUploadsFilename>>,
  TError = unknown,
>(
  filename: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiUploadsFilename>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetApiUploadsFilenameQueryKey(filename)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiUploadsFilename>>> = ({ signal }) =>
    getApiUploadsFilename(filename, { signal, ...requestOptions })

  return {
    queryKey,
    queryFn,
    enabled: filename !== null && filename !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getApiUploadsFilename>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }
}

export type GetApiUploadsFilenameQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiUploadsFilename>>
>
export type GetApiUploadsFilenameQueryError = unknown

export function useGetApiUploadsFilename<
  TData = Awaited<ReturnType<typeof getApiUploadsFilename>>,
  TError = unknown,
>(
  filename: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiUploadsFilename>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUploadsFilename>>,
          TError,
          Awaited<ReturnType<typeof getApiUploadsFilename>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiUploadsFilename<
  TData = Awaited<ReturnType<typeof getApiUploadsFilename>>,
  TError = unknown,
>(
  filename: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiUploadsFilename>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUploadsFilename>>,
          TError,
          Awaited<ReturnType<typeof getApiUploadsFilename>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiUploadsFilename<
  TData = Awaited<ReturnType<typeof getApiUploadsFilename>>,
  TError = unknown,
>(
  filename: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiUploadsFilename>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Serve an uploaded image (legacy unversioned path, referenced from the database)
 */

export function useGetApiUploadsFilename<
  TData = Awaited<ReturnType<typeof getApiUploadsFilename>>,
  TError = unknown,
>(
  filename: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiUploadsFilename>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiUploadsFilenameQueryOptions(filename, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}
